const state = {
  // app success / error/ warning messages object
  snackbar: {
    active: false,
    color: "success",
    timeout: "7000",
    message: "",
  },
};

const getters = {};

const actions = {};

const mutations = {
  showSnackbar(state, payload) {
    state.snackbar.color = payload.color;
    state.snackbar.message = payload.message;
    state.snackbar.timeout = payload.timeout;
    state.snackbar.active = true;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
